export const SPOTIFY_CLIENT = Object.freeze({
  CLIENT_ID: 'f367e292ec784630a80a027d0991b3e4',
  CLEINT_SECRET: 'ecb601407f13407daf805a532af0cc6c'
})

export const API_CONFIG = Object.freeze({
  baseAuthURL: 'https://accounts.spotify.com/authorize'
})

export const SCOPE_LIST = [
  'user-read-private',
  'user-read-email',
  'playlist-modify-private',
  'user-modify-playback-state',
  'playlist-modify-public',
  'user-read-currently-playing',
  'user-read-playback-state',
  'streaming',
  'user-read-recently-played',
  'user-library-modify'
]
